module.exports = __webpack_public_path__ + "img/img_tixian_tie@2x.8c789e34.png";